import {observer} from "mobx-react";
import {Component} from "preact";
import {BoxAvailabilityResponse} from "../model";
import {getBoxTypeName, resources} from "../resources";
import style from "./ChangeLockerDialog.module.css";
import {Button} from "./controls/Button";
import {Dialog, DialogContent, DialogTitle} from "./controls/Dialog";

type ChangeLockerHandler = (type: string) => void;

interface ChangeLockerDialogProps {
	open: boolean;
	onClose: () => void;
	onChangeLocker: ChangeLockerHandler;
	boxes?: BoxAvailabilityResponse[];
	pending: string | false;
}

export const ChangeLockerDialog = observer(
	class ChangeLockerDialog extends Component<ChangeLockerDialogProps> {
		render() {
			const {open, onClose, onChangeLocker, boxes, pending} = this.props;
			return (
				<Dialog open={open} onBackdropClick={onClose}>
					<DialogContent>
						<DialogTitle>{resources.strings.ChangeLocker}</DialogTitle>
						{boxes
							&& boxes.map(boxAvailability => (
								<ChangeLockerSizeButton
									key={boxAvailability.type}
									type={boxAvailability.type}
									available={boxAvailability.available}
									pending={pending == boxAvailability.type}
									disabled={!!pending}
									onClick={onChangeLocker}
								/>
							))}
						<Button onClick={onClose}>
							{resources.strings.Cancel}
						</Button>
					</DialogContent>
				</Dialog>
			);
		}
	},
);

interface ChangeLockerSizeButtonProps {
	type: string;
	pending: boolean;
	disabled: boolean;
	available: number;
	onClick: ChangeLockerHandler;
}

const ChangeLockerSizeButton = observer(
	class ChangeLockerSizeButton extends Component<ChangeLockerSizeButtonProps> {
		render() {
			const {type, pending, available, disabled} = this.props;
			return (
				<Button choice pending={pending} disabled={disabled || !available} onClick={this.handleClick}>
					<div>
						<div>{getBoxTypeName(type)}</div>
						<div class={style.availableBoxes}>{available} {resources.strings.Available}</div>
					</div>
				</Button>
			);
		}

		private handleClick = () => this.props.onClick(this.props.type);
	},
);
